// import React from 'react';
import Cookies from 'universal-cookie';
import jwt_decode from 'jwt-decode';
import getTenant from './getTenant';

const cookies = new Cookies();

const sld = window.location.hostname.split('.')[1];
export const domain = `.${sld}.com`;

interface JWT {
  tenantid: string;
  exp: number;
  userProfile: {
    firstName: string;
    lastName: string;
    email: string;
  };
}

const getJWT = (): JWT => {
  const token = getEncodedToken();
  if (!token) throw new Error('No JWT found.');

  return jwt_decode(token);
};

export const getEncodedToken = () => {
  const tenant = getTenant();
  let token =
    cookies.get(`auth-header-${tenant}`) ||
    cookies.get(`auth-header-vinci_content`) ||
    '';
  token = token.replace(/(Bearer: )/, '');

  return token;
};

export const isExpired = () => {
  try {
    const exp = getJWT().exp * 1000;
    const remaining = exp - Date.now();

    return remaining <= 0;
  } catch (e) {
    // return undefined
  }
};

export const isAuthed = () => {
  try {
    const exp = getJWT().exp * 1000;
    const remaining = exp - Date.now();

    return remaining > 0;
  } catch (e) {
    return false;
  }
};

export const getExp = () => {
  try {
    return new Date(getJWT().exp * 1000);
  } catch (e) {
    return new Date(0);
  }
};

// @ts-ignore
window.getJWT = getJWT;
// @ts-ignore
window.getTenant = getTenant;
// @ts-ignore
window.isExpired = isExpired;
// @ts-ignore
window.getExp = getExp;

export default getJWT;
